import React, { useState } from "react";
import { Users, ChevronDown, ChevronUp } from "lucide-react";

const faqData = [
    {
        question: "Tôi có thể liên hệ qua kênh nào?",
        answer: "Bạn có thể gọi hotline, gửi email hoặc điền form liên hệ."
    },
    {
        question: "Giờ làm việc của văn phòng?",
        answer: "Thứ Hai - Thứ Sáu: 8:00 - 17:30. Thứ Bảy: 8:00 - 12:00. Chủ Nhật: Đóng cửa."
    },
    {
        question: "Địa chỉ văn phòng ở đâu?",
        answer: "158 Cao Đức Lân, Phường An Phú, Quận 2, TP.HCM."
    }
];

export default function FAQAccordion() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="mt-8 bg-[#0a324b] p-8 rounded-3xl border border-[#1a5b82] shadow-lg">
            <div className="flex items-center gap-3 mb-6">
                <Users className="w-10 h-10 text-[#c9a063]" />
                <h3 className="text-3xl font-bold text-[#c9a063]">Bạn có câu hỏi?</h3>
            </div>

            <div className="space-y-4">
                {faqData.map((item, index) => (
                    <div key={index} className="bg-[#0b3a5c] rounded-xl border border-[#1a5b82]">
                        <button
                            className="w-full flex justify-between items-center px-6 py-4 text-left font-medium text-white hover:bg-[#0c3f61] transition"
                            onClick={() => toggle(index)}
                        >
                            {item.question}
                            {openIndex === index ? (
                                <ChevronUp className="w-5 h-5 text-[#c9a063]" />
                            ) : (
                                <ChevronDown className="w-5 h-5 text-[#c9a063]" />
                            )}
                        </button>
                        {openIndex === index && (
                            <div className="px-6 py-4 text-slate-300 border-t border-[#1a5b82]">
                                {item.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
